import InviraUserCrud from './InviraUserCrud.vue'
export {InviraUserCrud}
export default InviraUserCrud

